import { useState } from "react";
import { api, ApiError } from "../api/client";
import { useQuery } from "../api/useQuery";
import { useAuth } from "../auth/AuthContext";
import { fmtDateTime } from "../components/format";
import type { Device } from "../api/types";

export function DevicesPage() {
  const { me } = useAuth();
  const { data, error, loading, reload } = useQuery<{ items: Device[] }>("/api/v1/devices");
  const [busy, setBusy] = useState<string | null>(null);
  const [actionError, setActionError] = useState<string | null>(null);

  const canBlock = me?.role === "admin" || me?.role === "director";

  async function toggle(d: Device) {
    const action = d.is_blocked ? "разблокировать" : "заблокировать";
    if (!confirm(`Действительно ${action} устройство ${d.serial}?`)) return;

    setBusy(d.id);
    setActionError(null);
    try {
      await api.post(`/api/v1/devices/${d.id}/block`, { blocked: !d.is_blocked });
      reload();
    } catch (e) {
      setActionError(e instanceof ApiError ? e.message : "Не удалось изменить состояние");
    } finally {
      setBusy(null);
    }
  }

  return (
    <>
      <div className="page-head">
        <h2>Мобильные устройства</h2>
      </div>

      {error && <div className="error" role="alert">{error}</div>}
      {actionError && <div className="error" role="alert">{actionError}</div>}
      {loading && <p className="notice">Загрузка…</p>}

      {data && (
        <div className="card" style={{ padding: 0 }}>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Серийный номер</th>
                  <th>Модель</th>
                  <th>Android</th>
                  <th>Версия приложения</th>
                  <th>Территория</th>
                  <th>Последняя связь</th>
                  <th>Очередь фото</th>
                  <th>Состояние</th>
                  {canBlock && <th></th>}
                </tr>
              </thead>
              <tbody>
                {data.items.map((d) => (
                  <tr key={d.id}>
                    <td>{d.serial}</td>
                    <td>{d.model || "—"}</td>
                    <td>{d.os_version || "—"}</td>
                    <td>{d.app_version || "—"}</td>
                    <td>
                      {d.territory_name ?? <span className="muted">не привязано</span>}
                      {d.user_name && <div className="muted small">активировал: {d.user_name}</div>}
                    </td>
                    <td>{fmtDateTime(d.last_seen_at)}</td>
                    <td className="num">
                      {d.pending_files > 0
                        ? <span className="badge warn">{d.pending_files}</span>
                        : <span className="muted">—</span>}
                    </td>
                    <td>
                      {d.is_blocked
                        ? <span className="badge danger">заблокировано</span>
                        : <span className="badge ok">активно</span>}
                    </td>
                    {canBlock && (
                      <td>
                        <button className="secondary" disabled={busy === d.id} onClick={() => void toggle(d)}>
                          {d.is_blocked ? "Разблокировать" : "Заблокировать"}
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <p className="muted small" style={{ marginTop: 14 }}>
        Блокировка отзывает действующий токен устройства: доступ прекращается
        при первой же попытке связи, а накопленные данные остаются на аппарате.
      </p>
    </>
  );
}
